export default __webpack_public_path__ + "static/media/support-we-select.f2f6577e.svg";